import React, { useState} from 'react';

export const Dropdown = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="dropdown">
      <div className="dropdown-header" onClick={() => setOpen(!open)}>
        <span>{title}</span>
        <span className={`dash-arrow ${open ? 'open' : ''}`}>&#9662;</span>
      </div>
      <div className={`dropdown-content ${open ? 'open' : ''}`}>
        {children}
      </div>
    </div>
  );
};